import Container from '@ui/container/container';
import SearchInput from '@ui/search-input/search-input';
import { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

type AudiencesSearchProps = {
  expandedSearchWidth?: string;
};

const AudiencesSearch = ({ expandedSearchWidth }: AudiencesSearchProps) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const [, setParams] = useSearchParams();

  return (
    <Container
      className="flex fd-row flex-1 jc-flex-end"
      margin="0 0 0 auto"
      width="100%"
      background="transparent"
      ref={wrapperRef}
    >
      <SearchInput
        expandOnFocus
        width={
          expandedSearchWidth ? expandedSearchWidth : `${wrapperRef?.current?.getBoundingClientRect()?.width || 280}px`
        }
        trackInParams
        debounceTime={500}
        isClearable
        isBorderless
        onClear={() => {
          setParams((prev) => {
            const currParams = Object.fromEntries(prev.entries());
            return {
              ...currParams,
              search: '',
            };
          });
        }}
      />
    </Container>
  );
};

export default AudiencesSearch;
